import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Dialog from 'WeployDesignLanguage/Dialog';
import Button from 'WeployDesignLanguage/buttons/Button';

import InsightsOnboarding from '../../../../../assets/images/onboarding-insights.png';
import UpdatesOnboarding from '../../../../../assets/images/onboarding-updates.png';

const DEFAULT_PAGE = 1;

const StyledImage = styled.img`
  max-width: 100%;
`;

const StyledDescription = styled.div`
  ${props => props.theme.typography.subtitle1}
  color: ${props => props.theme.colors.text.primary};
  padding: ${props => props.theme.spacing[2]} ${props => props.theme.spacing[1]} 0;
`;

const OnboardingModal = ({ onClose, onNextClick, open }) => {
  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);

  const handleClose = () => {
    setCurrentPage(DEFAULT_PAGE);
    onClose();
  };

  const handleNextClick = () => {
    setCurrentPage(2);
    onNextClick();
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
    >
      { currentPage === DEFAULT_PAGE ?
        (
          <>
            <Dialog.Content>
              <StyledImage src={UpdatesOnboarding} />
              <StyledDescription>
                Easily manage time sensitive notifications in the Updates feed so that you can save time and stay on top of your tasks.
              </StyledDescription>
            </Dialog.Content>
            <Dialog.Actions>
              <Button
                appearance={Button.TEXT}
                onClick={handleNextClick}
              >
                Next
              </Button>
            </Dialog.Actions>
          </>
        ) : (
          <>
            <Dialog.Content>
              <StyledImage src={InsightsOnboarding} />
              <StyledDescription>
                Ease your worries about overlooking your contingent hires across your entire organisation. The Insights panel provides you with generated insights so you can take meaningful action on hiring patterns, compliance, and more.
              </StyledDescription>
            </Dialog.Content>
            <Dialog.Actions>
              <Button
                appearance={Button.TEXT}
                onClick={() => setCurrentPage(DEFAULT_PAGE)}
              >
                Back
              </Button>
              <Button
                appearance={Button.TEXT}
                onClick={handleClose}
              >
                Okay
              </Button>
            </Dialog.Actions>
          </>
        )
      }
    </Dialog>
  );
};

OnboardingModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onNextClick: PropTypes.func,
};

OnboardingModal.defaultProps = {
  open: false,
  onNextClick: () => {},
};

export default OnboardingModal;
